"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pick = _interopRequireDefault(require("./pick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var prevBodyStyles = {};

var disable = function disable() {
  var body = window.document.body;
  var scrollWidth = window.innerWidth - document.documentElement.clientWidth;
  prevBodyStyles = (0, _pick["default"])(body.style, 'position', 'left', 'top', 'right');
  Object.assign(body.style, {
    position: 'fixed',
    left: '0',
    top: "-".concat(window.scrollY, "px"),
    right: "".concat(scrollWidth, "px")
  });
};

var enable = function enable() {
  var body = window.document.body;
  var scrollY = body.style.top;
  Object.assign(body.style, prevBodyStyles);
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

var _default = {
  disable: disable,
  enable: enable
};
exports["default"] = _default;